import RowPayPal from './RowPayPal';

export default RowPayPal;
